import { render, staticRenderFns } from "./UL410.vue?vue&type=template&id=423f147f&scoped=true&"
import script from "./UL410.vue?vue&type=script&lang=js&"
export * from "./UL410.vue?vue&type=script&lang=js&"
import style0 from "./UL410.vue?vue&type=style&index=0&id=423f147f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423f147f",
  null
  
)

export default component.exports